
/* ============================================================
   AV-99: Shopify Cookie Banner Accessibility JS Overrides
   Injected by Melinda's Accessibility Tool
   ============================================================ */
(function() {
  'use strict';

  var BANNER_SELECTORS = '.shopify-pc__banner, #shopify-pc__banner, [id*="cookie-banner"], [class*="cookie-banner"], .shopify-privacy-banner';

  function isBannerContainer(el) {
    if (!el) return false;
    if (el.id === 'shopify-pc__banner') return true;
    if (typeof el.className === 'string' && el.className.indexOf('shopify-pc__banner') !== -1) return true;
    if (!/^(SECTION|DIV|ASIDE)$/i.test(el.tagName)) return false;
    return !!el.querySelector('button, a, input, [role="button"]');
  }

  function getBanner() {
    var banners = document.querySelectorAll(BANNER_SELECTORS);
    for (var i = 0; i < banners.length; i += 1) {
      if (isBannerContainer(banners[i])) return banners[i];
    }
    return null;
  }

  function fixBannerA11y(banner) {
    if (!banner || banner.dataset.a11yFixed) return;
    banner.dataset.a11yFixed = 'true';

    // 1. Set ARIA role — cookie banner should be an alertdialog
    banner.setAttribute('role', 'alertdialog');
    banner.setAttribute('aria-label', 'Cookie consent');
    banner.setAttribute('aria-describedby', 'cookie-banner-desc');

    // 2. Add heading structure
    var textEl = banner.querySelector('p, span, [class*="text"], [class*="message"]');
    if (textEl && !banner.querySelector('[role="heading"]')) {
      // Add a visually-hidden heading before the text
      var heading = document.createElement('h2');
      heading.className = 'sr-only';
      heading.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);';
      heading.textContent = 'Cookie Consent';
      heading.id = 'cookie-banner-heading';
      banner.insertBefore(heading, banner.firstChild);
      banner.setAttribute('aria-labelledby', 'cookie-banner-heading');
    }

    // ID for aria-describedby
    if (textEl && !textEl.id) {
      textEl.id = 'cookie-banner-desc';
    }

    // 3. Fix button roles and labels
    var buttons = banner.querySelectorAll('button');
    buttons.forEach(function(btn) {
      var text = (btn.textContent || '').trim().toLowerCase();

      if (!btn.getAttribute('aria-label')) {
        if (/accept|allow|agree/i.test(text)) {
          btn.setAttribute('aria-label', 'Accept cookies');
        } else if (/decline|reject|deny/i.test(text)) {
          btn.setAttribute('aria-label', 'Decline cookies');
        } else if (/settings|preferences|manage/i.test(text)) {
          btn.setAttribute('aria-label', 'Cookie preferences');
        }
      }

      // Ensure Space key works (some Shopify implementations use divs styled as buttons)
      btn.addEventListener('keydown', function(e) {
        if (e.key === ' ' || e.keyCode === 32) {
          e.preventDefault();
          btn.click();
        }
      });
    });

    // 4. Fix any non-button interactive elements
    var clickables = banner.querySelectorAll('[onclick], [class*="btn"]:not(button)');
    clickables.forEach(function(el) {
      if (el.tagName !== 'BUTTON' && el.tagName !== 'A') {
        el.setAttribute('role', 'button');
        el.setAttribute('tabindex', '0');

        el.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            el.click();
          }
        });
      }
    });

    // 5. Fix iframes within cookie banner (preferences panel)
    var iframes = banner.querySelectorAll('iframe');
    iframes.forEach(function(iframe) {
      if (!iframe.getAttribute('title')) {
        iframe.setAttribute('title', 'Cookie consent preferences');
      }
    });

    // 5b. Fix <label> tags with invalid explicit roles (AV-99 cookie #3)
    var labels = banner.querySelectorAll('label[role]');
    labels.forEach(function(label) {
      var role = label.getAttribute('role');
      // Remove invalid roles from label elements - labels shouldn't have explicit roles
      if (role && role !== 'presentation' && role !== 'none') {
        label.removeAttribute('role');
      }
    });

    // 5c. Remove prohibited aria-label from generic role elements (AV-99 cookie #13)
    var generics = banner.querySelectorAll('[role="generic"][aria-label], [role="generic"][aria-labelledby]');
    generics.forEach(function(el) {
      el.removeAttribute('aria-label');
      el.removeAttribute('aria-labelledby');
    });
    // Also check elements that implicitly have generic role (span, div without explicit role)
    var allEls = banner.querySelectorAll('[aria-label]');
    allEls.forEach(function(el) {
      var role = el.getAttribute('role');
      var tag = el.tagName.toLowerCase();
      // span elements without explicit role have implicit generic role
      if (!role && (tag === 'span') && el.getAttribute('aria-label')) {
        el.removeAttribute('aria-label');
      }
    });

    // 5d. Add heading structure to cookie category titles (AV-99 cookie #7)
    var categoryTitles = banner.querySelectorAll(
      '[class*="category"] > [class*="title"], [class*="cookie"] > [class*="title"], ' +
      '[class*="group"] > [class*="name"], [class*="consent"] [class*="heading"]'
    );
    categoryTitles.forEach(function(title) {
      if (title.tagName !== 'H2' && title.tagName !== 'H3' && !title.getAttribute('role')) {
        title.setAttribute('role', 'heading');
        title.setAttribute('aria-level', '3');
      }
    });

    // 6. Add live region for status updates
    var liveRegion = document.createElement('div');
    liveRegion.setAttribute('aria-live', 'assertive');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.className = 'sr-only';
    liveRegion.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);';
    liveRegion.id = 'cookie-banner-status';
    banner.appendChild(liveRegion);

    // Announce when cookies are accepted/declined
    buttons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var text = (btn.textContent || '').trim();
        var status = document.getElementById('cookie-banner-status');
        if (status) {
          status.textContent = text + ' - cookie preferences saved';
        }
      });
    });
  }

  // Keyboard: Escape to dismiss
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' || e.keyCode === 27) {
      var banner = getBanner();
      if (banner && banner.offsetParent !== null) {
        var declineBtn = banner.querySelector(
          'button[class*="decline"], button[class*="Decline"], button:last-of-type'
        );
        if (declineBtn) {
          declineBtn.click();
        }
      }
    }
  });

  // MutationObserver to catch dynamically-injected cookie banners
  function observeBanner() {
    var existing = getBanner();
    if (existing) {
      fixBannerA11y(existing);
    }

    var observer = new MutationObserver(function(mutations) {
      var banner = getBanner();
      if (banner && !banner.dataset.a11yFixed) {
        fixBannerA11y(banner);
        // AV-99 cookie #11: Place focus on banner for SR users
        if (banner.offsetParent !== null) {
          banner.setAttribute('tabindex', '-1');
          setTimeout(function() { banner.focus(); }, 200);
        }
      }
      // Check for new panels/overlays within the banner (preferences, details)
      mutations.forEach(function(mutation) {
        var added = mutation.addedNodes;
        for (var i = 0; i < added.length; i++) {
          var node = added[i];
          if (node.nodeType === 1 && node.closest && node.closest(BANNER_SELECTORS)) {
            // New content appeared inside banner - focus it
            var firstFocusable = node.querySelector('button, [href], input, [tabindex]:not([tabindex="-1"])');
            if (firstFocusable) {
              setTimeout(function() { firstFocusable.focus(); }, 100);
            }
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeBanner);
  } else {
    observeBanner();
  }
})();

/* ============================================================
   AV-99: Additional cookie banner hardening for April 2026 retest
   ============================================================ */
(function() {
  'use strict';

  var BANNER_SELECTORS = '.shopify-pc__banner, #shopify-pc__banner, [id*="cookie-banner"], [class*="cookie-banner"], .shopify-privacy-banner';
  var lastFocusedBanner = null;
  var lastBannerVisible = false;
  var lastInputModality = 'pointer';
  var dismissFocusPending = false;
  var PREFS_WRAPPER_ID = 'shopify-pc__prefs';
  var PREFS_DIALOG_ID = 'shopify-pc__prefs__dialog';
  var PREFS_TITLE_ID = 'shopify-pc__prefs__header-title';
  var PREFS_CLOSE_ID = 'shopify-pc__prefs__header-close';

  function getText(el) {
    return ((el && el.textContent) || '').replace(/\s+/g, ' ').trim();
  }

  function isVisible(el) {
    if (!el) return false;
    var style = window.getComputedStyle(el);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function isBannerContainer(el) {
    if (!el) return false;
    if (el.id === 'shopify-pc__banner') return true;
    if (typeof el.className === 'string' && el.className.indexOf('shopify-pc__banner') !== -1) return true;
    if (!/^(SECTION|DIV|ASIDE)$/i.test(el.tagName)) return false;
    return !!el.querySelector('button, a, input, [role="button"]');
  }

  function getBanner() {
    var banners = document.querySelectorAll(BANNER_SELECTORS);
    var fallback = null;
    for (var i = 0; i < banners.length; i += 1) {
      if (!isBannerContainer(banners[i])) continue;
      if (!fallback) fallback = banners[i];
      if (isVisible(banners[i])) return banners[i];
    }
    return fallback;
  }

  function ensureId(el, fallback) {
    if (!el.id) {
      el.id = fallback + '-' + Math.random().toString(36).slice(2, 8);
    }
    return el.id;
  }

  function addKeyboardActivation(el) {
    if (!el || el.dataset.a11yExtraBound) return;
    el.dataset.a11yExtraBound = 'true';
    el.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
        el.click();
      }
    });
  }

  function bindDismissFocus(control) {
    if (!control || control.dataset.a11yDismissFocusBound) return;
    var text = getText(control).toLowerCase();
    if (!/accept|allow|agree|decline|reject|deny/.test(text)) return;
    control.dataset.a11yDismissFocusBound = 'true';
    control.addEventListener('click', function() {
      dismissFocusPending = lastInputModality === 'keyboard';
      if (!dismissFocusPending) return;
      queueFocusRestore();
      scheduleDismissFocus(control);
    });
  }

  function focusSkipLink(attempt) {
    var skipLink = document.querySelector('a.skip-to-content[href="#MainContent"]');
    var tries = typeof attempt === 'number' ? attempt : 0;
    if (!skipLink || typeof skipLink.focus !== 'function') return;

    window.setTimeout(function() {
      var active = document.activeElement;
      if (hasVisiblePromoUi()) {
        dismissFocusPending = false;
        return;
      }
      if (
        tries > 0 &&
        active &&
        active !== document.body &&
        active !== document.documentElement &&
        active !== skipLink
      ) {
        return;
      }

      skipLink.focus();

      if (document.activeElement === skipLink || tries >= 6) {
        dismissFocusPending = false;
        return;
      }

      if (tries < 6) {
        focusSkipLink(tries + 1);
      }
    }, tries === 0 ? 140 : tries < 3 ? 140 : 220);
  }

  function queueFocusRestore(attempt) {
    if (!dismissFocusPending) return;
    var tries = typeof attempt === 'number' ? attempt : 0;
    var banner = getBanner();

    if ((!banner || !isVisible(banner)) && !hasVisiblePromoUi()) {
      focusSkipLink();
      return;
    }

    if (tries >= 12) {
      dismissFocusPending = false;
      return;
    }

    window.setTimeout(function() {
      queueFocusRestore(tries + 1);
    }, 120);
  }

  function scheduleDismissFocus(control) {
    if (!dismissFocusPending) return;
    [300, 800, 1500].forEach(function(delay) {
      window.setTimeout(function() {
        var banner = getBanner();
        var controlStillVisible = !!(
          control &&
          document.contains(control) &&
          isVisible(control)
        );
        if ((!banner || !isVisible(banner)) && !controlStillVisible && !hasVisiblePromoUi()) {
          focusSkipLink();
        }
      }, delay);
    });
  }

  function hasVisiblePromoUi() {
    var promoRoots = document.querySelectorAll('[id^="alia-popup-root-"], [id^="alia-root-"]');
    for (var i = 0; i < promoRoots.length; i += 1) {
      var root = promoRoots[i];
      if (root.getAttribute('aria-hidden') === 'true' || root.hidden) continue;
      if (!isVisible(root)) continue;
      var rect = root.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) continue;
      if (/try your luck|mystery discount|claim/i.test(getText(root))) return true;
    }
    return false;
  }

  function removeDuplicateHeadings(banner) {
    var headings = Array.prototype.slice.call(
      banner.querySelectorAll('h1, h2, h3, h4, h5, h6, [role="heading"]')
    );
    var normalized = {};

    headings.forEach(function(heading) {
      var text = getText(heading).toLowerCase();
      if (!text) return;
      if (!normalized[text]) {
        normalized[text] = heading;
        return;
      }

      if (heading.id === 'cookie-banner-heading' || heading.classList.contains('sr-only')) {
        heading.remove();
      }
    });

    var primaryHeading = banner.querySelector('h1, h2, h3, h4, h5, h6, [role="heading"], [class*="title"], [class*="heading"]');
    if (primaryHeading) {
      if (!/^H[1-6]$/.test(primaryHeading.tagName) && !primaryHeading.getAttribute('role')) {
        primaryHeading.setAttribute('role', 'heading');
        primaryHeading.setAttribute('aria-level', '2');
      }
      banner.setAttribute('aria-labelledby', ensureId(primaryHeading, 'cookie-banner-heading'));
      banner.removeAttribute('aria-label');
    }
  }

  function removeInvalidGroupButtons(banner) {
    banner.querySelectorAll('[role="button"]').forEach(function(el) {
      if (/^(BUTTON|A|INPUT)$/.test(el.tagName)) return;
      var interactiveChildren = el.querySelectorAll('button, a, input, select, textarea, [role="button"]').length;
      if (interactiveChildren > 1 || /cookie preferences accept cookies decline cookies/i.test(getText(el))) {
        el.removeAttribute('role');
        el.removeAttribute('tabindex');
      }
    });
  }

  function fixRequiredState(banner) {
    banner.querySelectorAll('*').forEach(function(el) {
      var text = getText(el);
      if (!/^required$/i.test(text) && !/^always active$/i.test(text)) return;

      el.setAttribute('aria-label', 'Required cookies, always active');
      var owner = el.closest('button, [role="switch"], [role="checkbox"], label, [class*="toggle"], [class*="switch"]');
      if (owner) {
        owner.setAttribute('aria-disabled', 'true');
        if (!owner.hasAttribute('aria-checked')) owner.setAttribute('aria-checked', 'true');
      }
    });
  }

  function fixControls(banner) {
    banner.querySelectorAll('[onclick], [class*="btn"], [role="button"], a').forEach(function(el) {
      if (!isVisible(el)) return;
      if (!/^(BUTTON|A|INPUT)$/.test(el.tagName)) {
        el.setAttribute('role', 'button');
        if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
      }
      addKeyboardActivation(el);
      bindDismissFocus(el);
    });

    banner.querySelectorAll('button, input, a').forEach(function(el) {
      if (!isVisible(el)) return;
      bindDismissFocus(el);
    });
  }

  function hardenBanner() {
    var banner = getBanner();
    var bannerVisible = !!(banner && isVisible(banner));

    if (!bannerVisible) {
      if (dismissFocusPending && lastBannerVisible && !hasVisiblePromoUi()) {
        queueFocusRestore();
      }
      lastBannerVisible = false;
      lastFocusedBanner = null;
      return;
    }

    lastBannerVisible = true;

    banner.setAttribute('role', 'alertdialog');
    banner.setAttribute('tabindex', '-1');

    removeDuplicateHeadings(banner);
    removeInvalidGroupButtons(banner);
    fixRequiredState(banner);
    fixControls(banner);

    if (banner !== lastFocusedBanner && isVisible(banner)) {
      lastFocusedBanner = banner;
      window.setTimeout(function() {
        banner.focus();
      }, 120);
    }
  }

  function syncPreferencesModal() {
    var prefsWrapper = document.getElementById(PREFS_WRAPPER_ID);
    var prefsDialog = document.getElementById(PREFS_DIALOG_ID);
    var banner = document.getElementById('shopify-pc__banner');
    var prefsOpen = !!(prefsWrapper && prefsDialog && isVisible(prefsWrapper) && isVisible(prefsDialog));

    if (banner) {
      if (prefsOpen && banner.dataset.a11yHiddenForPrefs !== 'true') {
        banner.dataset.a11yHiddenForPrefs = 'true';
        banner.setAttribute('aria-hidden', 'true');
        banner.style.setProperty('display', 'none', 'important');
      } else if (banner.dataset.a11yHiddenForPrefs === 'true') {
        if (!prefsOpen) {
          banner.removeAttribute('aria-hidden');
          banner.style.removeProperty('display');
          delete banner.dataset.a11yHiddenForPrefs;
        }
      }
    }

    if (!prefsOpen) return;

    var prefsTitle = document.getElementById(PREFS_TITLE_ID);
    if (prefsTitle && !getText(prefsTitle)) {
      prefsTitle.textContent = 'Cookie preferences';
    }

    var closeButton = document.getElementById(PREFS_CLOSE_ID);
    if (closeButton && !closeButton.getAttribute('aria-label')) {
      closeButton.setAttribute('aria-label', 'Close cookie preferences');
    }
  }

  document.addEventListener('keydown', function(e) {
    if (e.metaKey || e.ctrlKey || e.altKey) return;
    lastInputModality = 'keyboard';
  }, true);

  ['mousedown', 'pointerdown', 'touchstart'].forEach(function(eventName) {
    document.addEventListener(eventName, function() {
      lastInputModality = 'pointer';
    }, true);
  });

  function observeBanner() {
    hardenBanner();
    syncPreferencesModal();
    var observer = new MutationObserver(function() {
      hardenBanner();
      syncPreferencesModal();
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'aria-hidden']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeBanner);
  } else {
    observeBanner();
  }
})();
